
import axios from 'axios';
import $ from 'jquery';

axios.defaults.timeout = 5000;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL || "";

// var __vue__ = {}
//header请求头key
var authorizationKey = "authorization";

//根据状态码回调
var statusCodeHandles = { "403": function () { } }

export function http(inject403Code = true) {

    //处理接口返回403时自动跳转到指定的地址
    if (inject403Code) { //注入时可配置是否默认处理403
        http.prototype.addStatusCodeHandle(res => {
            var header = res.headers || {}
            var url = header.location || header["x-location"] || ""
            if (!url && header.get) {
                url = header.get("location") || header.get("x-location")
            }
            if (url) {
                if (url.indexOf("returnurl") > -1) {
                    window.location = url
                    return
                }
                window.location = url + "?returnurl=" + encodeURIComponent(location.origin + location.pathname + location.search);
                return
            }
            //从系统配置中获取
            let urlx = window.location.protocol + "//" + window.location.host + "/login"
            window.location = urlx

        }, 403);

        http.prototype.inject405CodeHandle() //405权限处理
    }

}
http.prototype.inject405CodeHandle = function () {
    http.prototype.addStatusCodeHandle(() => {
        console.log("请求的接口与页面不匹配或未配置权限")
        return
    }, 405);
}

//http request 拦截器
axios.interceptors.request.use(
    config => {
        config.headers = getHeaders(config);
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.headers && response.headers[authorizationKey]) {
            http.prototype.setAuthorization(response.headers[authorizationKey]);
        }
        return response;
    },
    error => {
        if (error.response) {
            let handle = statusCodeHandles[error.response.status];
            if (handle) {
                handle(error.response);
            }
        }
        return Promise.reject(error);
    }
)

//默认 content-type
http.prototype.defaults = {
    headers: { "content-type": "application/json; charset=UTF-8" }
};

//设置http请求地址
http.prototype.setBaseURL = function (apiBaseUrl) {
    axios.defaults.baseURL = apiBaseUrl
}

//设置根据状态码回调
http.prototype.addStatusCodeHandle = function (f, code = "*") {
    let vcode = code || "*"
    if (typeof f != "function") {
        return
    }
    statusCodeHandles[vcode] = f
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.get = function (url, params = {}, config = {}, success = "", fail = "") {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params }, config)
            .then(response => {
                if (response.status == 200) {
                    showSuccessNotify(success)
                    resolve(response.data);
                }else{
                    showSuccessNotify(success)
                    resolve({});
                }
            })
            .catch(err => {
                showFailedNotify(fail, err)
                reject(err)
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.post = function (url, data = {}, config = {}, success = "", fail = "") {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config)
            .then(response => {
                if (response.status == 200) {
                    showSuccessNotify(success)
                    resolve(response.data);
                }else{
                    showSuccessNotify(success)
                    resolve({});
                }
            }, err => {
                showFailedNotify(fail, err)
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.put = function (url, data = {}, config = {}, success = "", fail = "") {
    return new Promise((resolve, reject) => {
        axios.put(url, data, config)
            .then(response => {
                if (response.status == 200) {
                    showSuccessNotify(success)
                    resolve(response.data);
                }else{
                    showSuccessNotify(success)
                    resolve({});
                }
            }, err => {
                showFailedNotify(fail, err)
                reject(err);
            });
    });
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.upload = function (url, data = {}, config = {}, success = "", fail = "") {
    return new Promise((resolve, reject) => {
        let nconf = Object.assign({ headers: { "Content-Type": "multipart/form-data" } }, config);
        axios.post(url, data, nconf)
            .then(response => {
                if (response.status == 200) {
                    showSuccessNotify(success)
                    resolve(response.data);
                }else{
                    showSuccessNotify(success)
                    resolve({});
                }
            }, err => {
                showFailedNotify(fail, err)
                reject(err)
            })
    })
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.del = function (url, data = {}, config = {}, success = "", fail = "") {
    return new Promise((resolve, reject) => {
        axios.delete(url, { data: data }, config)
            .then(response => {
                if (response.status == 200) {
                    showSuccessNotify(success)
                    resolve(response.data);
                }else{
                    showSuccessNotify(success)
                    resolve({});
                }
            }, err => {
                showFailedNotify(fail, err)
                reject(err)
            })
    })
}

/**
 * ajax同步封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.xget = function (url, params = {}, config = {}, success = "", fail = "") {
    return http.prototype.ajax("GET", url, params, config, success, fail)
}

/**
 * ajax同步封装post方法
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.xpost = function (url, params = {}, config = {}, success = "", fail = "") {
    return http.prototype.ajax("POST", url, params, config, success, fail)
}

/**
 * ajax同步封装put方法
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.xput = function (url, params = {}, config = {}, success = "", fail = "") {
    return http.prototype.ajax("PUT", url, params, config, success, fail)
}

/**
 * ajax同步封装del方法
 * @param url
 * @param data
 * @returns {Promise}
 */
http.prototype.xdel = function (url, params = {}, config = {}, success = "", fail = "") {
    return http.prototype.ajax("DELETE", url, params, config, success, fail)
}

http.prototype.ajax = function (method, url, params, config, success, fail) {
    var result = null
    $.ajax({
        type: method, //请求方式
        async: false, // fasle表示同步请求，true表示异步请求
        xhrFields: { withCredentials: true },
        headers: getHeaders(config || {}),
        url: getURL(url),//请求地址
        data: params, //请求参数
        beforeSend: function (httpRequest, settings) {
            settings.contentType = settings.headers["content-type"]
            if ((settings.contentType || "").indexOf("/json") > 0) {
                settings.data = JSON.stringify(params);
            }
        },
        success: function (res) { //请求成功   
            showSuccessNotify(success)
            result = res
        },
        error: function (err) {  //请求失败，包含具体的错误信息  
            showFailedNotify(fail, err)
            if (err.status) {
                let handle = statusCodeHandles[err.status];
                if (handle) {
                    var hd = { headers: {} }
                    hd.headers.get = err.getResponseHeader
                    handle(hd);
                }
            }
        },
        complete(xhr) {
            var token = xhr.getResponseHeader(authorizationKey);
            if (token) {
                http.prototype.setAuthorization(token)
            }
        }
    })
    return result
}

//消除header
http.prototype.clearAuthorization = function () {
    window.localStorage.removeItem(authorizationKey);
    clearCookie()
}

//设置需要的header
http.prototype.setAuthorization = function (token) {
    if (token) {
        window.localStorage.setItem(authorizationKey, token);
    }
}
//设置需要的header
http.prototype.getAuthorization = function () {
    return window.localStorage.getItem(authorizationKey);
}
//获取response返回的header  
function getHeaders(config) {
    var headers = {};
    var defaults = {};
    Object.assign(defaults, http.prototype.defaults.headers);
    for (var k in defaults) {
        headers[k.toLowerCase()] = defaults[k];
    }
    var token = http.prototype.getAuthorization();
    if (token) {
        headers[authorizationKey] = token;
    }
    for (var n in config.headers || {}) {
        headers[n.toLowerCase()] = config.headers[n];
    }
    return headers
}

function getURL(url) {
    if (url.indexOf(".") == 0) {
        return url
    }
    return axios.defaults.baseURL + url  //请求地址
}

//显示成功提示
function showSuccessNotify(msg) {
    if (!msg) {
        return
    }

}

//显示失败提示
function showFailedNotify(msg, err) {
    if (!msg) {
        return
    }
    if (err.response) {
        err = err.response.data
    }
    if (typeof msg == "string") {
        msg = msg + err
    }
    if (typeof msg == "boolean") {
        msg = err + ""
    }
}


function clearCookie() {
    var keys = document.cookie.match(/[^ =;]+(?==)/g)
    if (keys) {
        for (var i = keys.length; i--;) {
            document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
            document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
            document.cookie = keys[i] + '=0;path=/;domain=ratingdog.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
        }
    }
}